import { useSelector } from "react-redux";
import { Bounce, ToastContainer, toast } from "react-toastify";

export { toast };

export default function ToastNotification() {
  const mode = useSelector((state) => state.theme.mode);
  const isDarkMode = mode !== "light";
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={isDarkMode ? "dark" : "light"}
      transition={Bounce}
    />
  );
}
